module.exports = __webpack_public_path__ + "img/chat_icon_dark_green.aabf51e6.svg";